/** @jsx jsx */
import { jsx } from "theme-ui"
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link, navigate } from "gatsby";
import { useCart } from '../context/cart-context';
import { useRef } from "react";

const BuyButton = ({ variants, handle }) => {
  const ref = useRef();
  const { addItemToCart } = useCart();

  const lowestPrice = variants[0].product.priceRangeV2.minVariantPrice;

  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: lowestPrice.currencyCode,
  }).format(lowestPrice.amount);

  const showToolTip = () => {
    const floater = ref.current.querySelector('span');

    floater.style.visibility = 'visible';
    ref.current.classList.add('visible');

    setTimeout(() => {
      ref.current.classList.remove('visible');
      floater.style.visibility = 'hidden';
    }, 1000);
  };

  const handleClick = async (event) => {
    event.preventDefault();

    if (variants.length > 1) {
      navigate(`/product/${handle}`);
      return;
    }

    showToolTip();
    await addItemToCart({
      variantId: variants[0].shopifyId,
      quantity: 1,
    });
  };

  return (
    <button 
      ref={ref}
      sx={{
        color: 'white',
        bg: 'redAccent',
        border: 0, 
        borderRadius: 6, 
        fontSize: '16px',
        fontWeight: 400,
        py: '6px',
        px: '8px',
        width: 'auto',
      }}
      onClick={handleClick}
    >
      {variants.length > 1 ? `Buy From ${formatted}` : `Add to Cart ${formatted}`}
      <span
        sx={{
          bg: 'teal',
          bottom: '50%',
          borderRadius: 6,
          color: 'white',
          display: 'block',
          fontSize: '1.5rem',
          opacity: 0,
          p: 1,
          position: 'absolute',
          right: 0,
          visibility: 'hidden',
          '.visible &': {
            animation: 'tip 1000ms ease-out',
          },
          '@keyframes tip': {
            '0%': {
              opacity: 0,
              bottom: '50%',
            },
            '80%': {
              opacity: 1,
            },
            '100%': {
              bottom: '120%',
              opacity: 0,
            },
          },
        }}
      >
        Added!
      </span>
    </button>
  )
}

const ProductCard = ({ product }) => {

  if(!product.images[0] || product.status === "DRAFT") {
    return null;
  }

  return(
    <div>
        <div 
          sx={{ 
            position: 'relative',
            bg: 'white',
            border: '5px solid white',
            borderRadius: 8,
            height: '100%',
            boxShadow: t => `0 4px 4px ${t.colors.shadow}`,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            mb: '1rem',
            pb: '0.75rem',
          }}
        >
          <Link to={`/product/${product.handle}`}>
            <GatsbyImage 
              alt={product.title} 
              image={product.images[0].gatsbyImageData} 
              sx={{
                width: '100%',
              }}
            />
            <h2 
              sx={{
                color: 'text', 
                fontWeight: '300',
                fontSize: '1.2rem',
                textAlign: 'center',
              }} 
            >
              {product.title} 
            </h2>
          </Link>
          <div
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              alignItems: 'baseline',
              mt: 'auto',
              px: '8px',
            }}
          >
            <BuyButton variants={product.variants} handle={product.handle} />
          </div>

          <p
            sx={{
              position: 'absolute',
              top: '0.25rem',
              right: '0.25rem',
              bg: 'prodType',
              color: 'white',
              fontSize: '0.75rem',
              lineHeight: 1,
              m: 0,
              p: 1,
              fontWeight: '600',
              borderRadius: 6,

              '&[data-type="Earrings"]': {
                bg: 'greenAccent',
              },
              '&[data-type="Necklaces"]': {
                bg: 'redAccent',
              },
              '&[data-type="Crystals"]': {
                bg: 'purpleAccent',
              }
            }}
            data-type={product.productType}
          >
            {product.productType}
          </p>

        </div> 
    </div>
    
  )
}

export default ProductCard
